import FaceIcon from '@mui/icons-material/Face'
import adjustLongText from 'utilities/adjustLongText'
import { printCustomerName } from 'components/CustomerAdmin/utils'
import CustomerButtonUI from 'views/Sale/SaleUI/CartOrderPanel/CustomerButtonUI'
import usePaymentContext from './hook/usePaymentContext'

interface IProps {
    onClickCustomer?: () => void
    orderCustomerID?: string
    disabled?: boolean
}

function CustomerSelection({
    onClickCustomer,
    orderCustomerID,
    disabled,
}: IProps) {
    const { seperateSomethingInLongText } = adjustLongText()
    const { customerList } = usePaymentContext()

    if (onClickCustomer)
        return (
            <CustomerButtonUI
                disabled={disabled}
                variant="outlined"
                startIcon={<FaceIcon sx={{ transform: 'scale(1.3)' }} />}
                fullWidth
                color="primary"
                sx={{
                    height: '70px',
                    backgroundColor: (theme) =>
                        theme.palette.outlinePrimary.main,
                    color: (theme) =>
                        theme.palette.mode === 'dark'
                            ? theme.palette.default.contrastText
                            : theme.palette.primary.main,
                }}
                onClick={onClickCustomer}
                title={seperateSomethingInLongText(
                    printCustomerName(
                        customerList.find(
                            (a) => a.customerID === (orderCustomerID ?? ''),
                        ),
                    ),
                )}
            ></CustomerButtonUI>
        )
    return <></>
}
export default CustomerSelection
